import { render, staticRenderFns } from "./automationsView.vue?vue&type=template&id=528fed82"
import script from "./automationsView.vue?vue&type=script&lang=js"
export * from "./automationsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports